export const EnterpriseStorageKeys = {
  helpComplete: 'helpComplete',
};
